import { describeFields } from '../common/fields';
import { NotesCategorySchema } from './schemas';

export const NOTES_CATEGORY_FIELDS = describeFields(NotesCategorySchema, {
  subject: {},
  category: {},
  label: {},
  shortLabel: {},
  notes: {},
});
